import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { StarOutline } from '@material-ui/icons';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { IPartnerUgoRating } from '../../interfaces';
import { useSavePartnerRating } from './useSavePartnerRating';
import PartnerRatingTableRow from './PartnerRatingTableRow';

const useStyles = makeStyles({
  table: {
    '& thead, & tbody': {
      '& tr': {
        '& th': {
          backgroundColor: '#F5F5F5',
          fontWeight: 'bold',
        },
      },
    },
  },
});

const validationSchema = yup.array().of(
  yup.object().shape({
    partnerRatings: yup.array().of(
      yup.object().shape({
        criteriaRatings: yup.array().of(
          yup.object().shape({
            value: yup
              .number()
              .nullable()
              .required('Рейтинг обязателен')
              .min(1, 'Минимальное значение 1')
              .max(5, 'Максимальное значение 5'),
          }),
        ),
      }),
    ),
  }),
);

interface IProps extends DialogProps {
  partners: IPartnerUgoRating[];
  onSaveRating(): void;
}

const SavePartnerUgoRatingDialog = ({ partners, onSaveRating, ...props }: IProps) => {
  const { saveRating, loading } = useSavePartnerRating(onSaveRating);

  // Styles
  const classes = useStyles();

  return (
    <Dialog {...props} fullWidth maxWidth="lg" scroll="body">
      <DialogTitle>
        <b>Оценка партнеров</b>
      </DialogTitle>

      <Formik initialValues={partners} validationSchema={validationSchema} onSubmit={saveRating}>
        {({ values }) => (
          <Form>
            <DialogContent style={{ padding: 0 }}>
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>Партнер</b>
                      </TableCell>

                      <TableCell>
                        <b>Номенклатура</b>
                      </TableCell>

                      <TableCell>
                        <b>Номер дефектного акта</b>
                      </TableCell>

                      <TableCell>
                        <b>Файл ДА</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {values.map((partner, partnerIndex) => (
                      <PartnerRatingTableRow
                        key={partner.defectActRatingUgoId}
                        data={partner}
                        disabled={loading}
                        partnerIndex={partnerIndex}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>

            <DialogActions>
              <Button color="primary" variant="contained" type="submit" disabled={loading} startIcon={<StarOutline />}>
                Оценить партнеров УГО
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default SavePartnerUgoRatingDialog;
